

{
  "familyId": "GELD-TELLEN",
  "questions": [
    {
      "id": "GELD-TELLEN-001",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel geld is dit in totaal?\n2 euro + 50 cent + 20 cent",
      "context": null,
      "options": ["€ 2,70", "€ 2,07", "€ 2,50", "€ 2,72"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 270, "mode": "display", "targetCents": 270}}],
      "conceptId": "geld_tellen_euro_cent",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "geld.cent-als-decimaal-verward", "label": "Schrijft 70 cent als ,07", "optionIndex": 1 },
          { "id": "geld.munt-vergeten", "label": "Vergeet de 20-centmunt", "optionIndex": 2 },
          { "id": "geld.optel-fout", "label": "Rekent 50 + 20 als 72", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Tel alle bedragen op: 2 euro = 200 cent, 50 cent, 20 cent. Totaal: 200 + 50 + 20 = 270 cent = € 2,70.",
        "solutionSteps": [
          "Reken de euro's om naar centen: 2 euro = 200 cent",
          "Tel alle centen op: 200 + 50 + 20 = 270 cent",
          "Reken terug naar euro's: 270 cent = € 2,70"
        ],
        "distractorExplanations": {
          "0": "Correct! 2 euro + 50 cent + 20 cent = € 2,70.",
          "1": "Fout: je hebt de cent-bedragen niet goed opgeteld. 50 + 20 = 70 cent, niet 7 cent. Totaal: € 2,70.",
          "2": "Fout: je bent de 20 cent vergeten. 2 euro + 50 cent + 20 cent = € 2,70.",
          "3": "Fout: controleer je optelling. 50 + 20 = 70, niet 72. Totaal: € 2,70."
        }
      }
    },
    {
      "id": "GELD-TELLEN-002",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel cent is € 1,35?",
      "context": null,
      "options": ["135 cent", "150 cent", "1.350 cent", "35 cent"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 135, "mode": "display", "targetCents": 135}}],
      "conceptId": "geld_euro_naar_cent",
      "variantIndex": 2,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "geld.afronden-naar-50", "label": "Rondt op naar 150 cent", "optionIndex": 1 },
          { "id": "geld.euro-als-1000", "label": "Denkt dat 1 euro = 1.000 cent", "optionIndex": 2 },
          { "id": "geld.euro-vergeten", "label": "Vergeet de euro (alleen 35 cent)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "1 euro = 100 cent. Dus € 1,35 = 1 × 100 + 35 = 135 cent. De cijfers voor de komma zijn euro's (×100), de cijfers na de komma zijn centen.",
        "solutionSteps": [
          "Onthoud: 1 euro = 100 cent",
          "Reken de euro's om: 1 euro = 100 cent",
          "Tel de centen erbij: 100 + 35 = 135 cent"
        ],
        "distractorExplanations": {
          "0": "Correct! € 1,35 = 135 cent.",
          "1": "Je hebt de 35 cent afgerond naar 50 cent. Maar je moet het precieze bedrag omrekenen: 1 euro is 100 cent, plus 35 cent is 135 cent.",
          "2": "Fout: 1 euro = 100 cent, niet 1.000 cent. € 1,35 = 135 cent.",
          "3": "Fout: je bent de euro vergeten. 1 euro = 100 cent, plus 35 cent = 135 cent."
        }
      }
    },
    {
      "id": "GELD-TELLEN-003",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Welke munten heb je nodig om precies € 0,85 te betalen met zo min mogelijk munten?",
      "context": null,
      "options": [
        "1 × 50 cent + 1 × 20 cent + 1 × 10 cent + 1 × 5 cent",
        "1 × 50 cent + 1 × 30 cent + 1 × 5 cent",
        "8 × 10 cent + 1 × 5 cent",
        "17 × 5 cent"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 85, "mode": "display", "targetCents": 85}}],
      "conceptId": "geld_munten_samenstellen",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "geld.muntwaarde-onbekend", "label": "Denkt dat er een 30-centmunt bestaat", "optionIndex": 1 },
          { "id": "geld.niet-min-munten", "label": "Klopt qua bedrag, maar te veel munten (9)", "optionIndex": 2 },
          { "id": "geld.niet-min-munten", "label": "Klopt qua bedrag, maar te veel munten (17)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Begin met de grootste munt die past: 50 cent. Dan 20 cent (totaal 70). Dan 10 cent (totaal 80). Dan 5 cent (totaal 85). Dat zijn 4 munten: 50 + 20 + 10 + 5 = 85 cent.",
        "solutionSteps": [
          "Begin met de grootste munt: 50 cent",
          "Nog nodig: 85 − 50 = 35 cent → 20 cent",
          "Nog nodig: 35 − 20 = 15 cent → 10 cent",
          "Nog nodig: 15 − 10 = 5 cent → 5 cent",
          "Totaal: 50 + 20 + 10 + 5 = 85 cent ✓ (4 munten)"
        ],
        "distractorExplanations": {
          "0": "Correct! 50 + 20 + 10 + 5 = 85 cent met maar 4 munten.",
          "1": "Fout: er bestaat geen munt van 30 cent. De munten zijn: 1, 2, 5, 10, 20, 50 cent en 1, 2 euro.",
          "2": "Het bedrag klopt, maar dat zijn 9 munten. Met 50 + 20 + 10 + 5 heb je maar 4 munten nodig.",
          "3": "Het bedrag klopt, maar dat zijn 17 munten! Met 50 + 20 + 10 + 5 heb je maar 4 munten nodig."
        }
      }
    },
    {
      "id": "GELD-TELLEN-004",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Hoeveel geld heeft Lena in totaal?\nZe heeft: 1 biljet van € 5, 2 munten van € 1 en 3 munten van 50 cent.",
      "context": null,
      "options": ["€ 8,50", "€ 7,50", "€ 9,00", "€ 8,00"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 850, "mode": "display", "targetCents": 850}}],
      "conceptId": "geld_tellen_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.77,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "geld.aantal-genegeerd", "label": "Telt 2 × € 1 als € 1", "optionIndex": 1 },
          { "id": "geld.halve-fout", "label": "Rekent 3 × 50 cent als € 2", "optionIndex": 2 },
          { "id": "geld.halve-munten-vergeten", "label": "Vergeet de 50-centmunten", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Tel op: € 5 + 2 × € 1 + 3 × € 0,50 = € 5 + € 2 + € 1,50 = € 8,50.",
        "solutionSteps": [
          "Biljet: € 5",
          "Euromunten: 2 × € 1 = € 2",
          "50-centmunten: 3 × € 0,50 = € 1,50",
          "Totaal: € 5 + € 2 + € 1,50 = € 8,50"
        ],
        "distractorExplanations": {
          "0": "Correct! € 5 + € 2 + € 1,50 = € 8,50.",
          "1": "Je hebt de 2 euromunten als 1 euro geteld. 2 munten van 1 euro is samen 2 euro. Totaal: € 5 + € 2 + € 1,50 = € 8,50.",
          "2": "Je hebt 3 munten van 50 cent geteld als 2 euro. Maar 3 × 50 cent = 150 cent = € 1,50. Totaal: € 5 + € 2 + € 1,50 = € 8,50.",
          "3": "Fout: je bent de 50-centmunten vergeten. 3 × 50 cent = € 1,50. Totaal: € 8,50."
        }
      }
    },
    {
      "id": "GELD-TELLEN-005",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "ordering",
      "question": "Zet deze bedragen op volgorde van klein naar groot.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["€ 3,25", "€ 3,05", "€ 2,99", "€ 3,20"],
        "correctOrder": [2, 1, 3, 0]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Bedragen vergelijken",
            "content": "Vergelijk eerst de euro's (vóór de komma). Bij gelijke euro's: vergelijk de centen (na de komma). Let op: ,05 is 5 cent, niet 50 cent.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_sorteren",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "€ 2,99 heeft minder euro's en is dus het kleinst. Daarna komen de drie 3-euro-bedragen op centen: 05 < 20 < 25. Volgorde: € 2,99 → € 3,05 → € 3,20 → € 3,25.",
        "solutionSteps": [
          "€ 2,99 → 2 euro, dus kleinste",
          "Daarna: vergelijk de centen van 3-euro-bedragen",
          "5 < 20 < 25 → € 3,05 → € 3,20 → € 3,25",
          "Volgorde: € 2,99 → € 3,05 → € 3,20 → € 3,25"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-006",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "fill_in",
      "question": "Een winkelier telt de kassa: 1 biljet van € 10, 3 munten van € 2 en 4 munten van 20 cent. Hoeveel geld is er in totaal? Typ het bedrag (bijv. 5,60).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["16,80", "€16,80", "€ 16,80", "16.80"],
        "caseSensitive": false,
        "placeholder": "€ ..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Geld tellen in stappen",
            "content": "€ 10 (biljet) + 3 × € 2 = € 6 + 4 × € 0,20 = € 0,80. Totaal: € 10 + € 6 + € 0,80 = € 16,80.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_tellen_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Biljet: € 10. Euromunten: 3 × € 2 = € 6. Centmunten: 4 × € 0,20 = € 0,80. Totaal: € 10 + € 6 + € 0,80 = € 16,80.",
        "solutionSteps": [
          "Biljet: € 10",
          "3 × € 2 = € 6",
          "4 × € 0,20 = € 0,80",
          "Totaal: € 10 + € 6 + € 0,80 = € 16,80"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-007",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over geld waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "€ 2,50 = 250 cent", "isTrue": true },
          { "text": "3 munten van 50 cent = € 1,00", "isTrue": false },
          { "text": "€ 0,75 is meer dan € 0,70", "isTrue": true },
          { "text": "100 cent = € 1,00", "isTrue": true },
          { "text": "€ 4,05 = 45 cent", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Euro's en centen omrekenen",
            "content": "1 euro = 100 cent. 3 × 50 cent = 150 cent = € 1,50 (niet € 1,00). € 4,05 = 405 cent (niet 45 cent — de 4 euro = 400 cent).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_waar_onwaar",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "€ 2,50 = 250 cent ✓. 3 × 50 cent = € 1,50, niet € 1,00 ✗. € 0,75 > € 0,70 ✓. 100 cent = € 1,00 ✓. € 4,05 = 405 cent, niet 45 cent ✗.",
        "solutionSteps": [
          "€ 2,50 = 250 cent → WAAR",
          "3 × 50 = 150 cent = € 1,50 → ONWAAR",
          "75 cent > 70 cent → WAAR",
          "100 cent = € 1,00 → WAAR",
          "€ 4,05 = 405 cent → ONWAAR"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-008",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "fill_in",
      "question": "Tom heeft 2 biljetten van € 5, 4 munten van € 0,50 en 7 munten van 10 cent. Hoeveel geld heeft hij in totaal? Typ in formaat €,..",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["12,70", "€12,70", "€ 12,70", "12.70"],
        "caseSensitive": false,
        "placeholder": "€ ..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "money", "showWhen": "wrong", "data": {"amount": 1270, "mode": "display", "targetCents": 1270}}],
      "conceptId": "geld_tellen_meerdere",
      "variantIndex": 8,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Biljetten: 2 × € 5 = € 10. 50-centmunten: 4 × € 0,50 = € 2. 10-centmunten: 7 × € 0,10 = € 0,70. Totaal: € 10 + € 2 + € 0,70 = € 12,70.",
        "solutionSteps": [
          "2 × € 5 = € 10",
          "4 × € 0,50 = € 2,00",
          "7 × € 0,10 = € 0,70",
          "Totaal: € 12,70"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-009",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "categorize",
      "question": "Bestaat deze munt of dit biljet in Nederland?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Bestaat", "Bestaat niet"],
        "items": [
          { "text": "munt van 20 cent", "correctCategory": 0 },
          { "text": "munt van 30 cent", "correctCategory": 1 },
          { "text": "biljet van € 10", "correctCategory": 0 },
          { "text": "biljet van € 3", "correctCategory": 1 },
          { "text": "munt van € 2", "correctCategory": 0 },
          { "text": "munt van € 5", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Wat bestaat?", "content": "Munten: 1, 2, 5, 10, 20, 50 cent en € 1, € 2. Biljetten: € 5, € 10, € 20, € 50, € 100, € 200, € 500. Er bestaat geen muntje van 30 cent, geen biljet van € 3, en € 5 is een biljet — geen munt.", "icon": "lightbulb"}}],
      "conceptId": "geld_munten_biljetten_bestaan",
      "variantIndex": 9,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Munten: 1, 2, 5, 10, 20, 50 cent en € 1, € 2. Biljetten: € 5, € 10, € 20, € 50, € 100, € 200, € 500. Een muntje van 30 cent, een biljet van € 3 en een munt van € 5 bestaan niet.",
        "solutionSteps": [
          "20 cent → bestaat ✓",
          "30 cent → bestaat niet ✗",
          "€ 10 → biljet ✓",
          "€ 3 → bestaat niet ✗",
          "€ 2 → munt ✓",
          "€ 5 → wel als biljet, niet als munt ✗"
        ]
      }
    },
    {
      "id": "GELD-TELLEN-010",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "multiple_choice",
      "question": "Mees heeft € 3,45 in zijn portemonnee. Zijn vader stopt er nog 3 munten van 20 cent bij. Hoeveel heeft hij nu?",
      "context": null,
      "options": ["€ 4,05", "€ 3,65", "€ 3,75", "€ 4,15"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Geld bijtellen",
            "content": "3 × 20 cent = 60 cent = € 0,60. Tel op: € 3,45 + € 0,60 = € 4,05 (want 45 + 60 = 105 cent = € 1,05, dus € 3 + € 1,05 = € 4,05).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "geld_optellen_contextueel",
      "variantIndex": 10,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "geld.aantal-genegeerd", "label": "Telt maar 1 × 20 cent bij", "optionIndex": 1 },
          { "id": "geld.aantal-onjuist", "label": "Rekent 3 × 10 cent in plaats van 3 × 20 cent", "optionIndex": 2 },
          { "id": "geld.overdraag-vergeten", "label": "Vergeet de overdracht bij 45 + 60", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "3 × 20 cent = 60 cent. € 3,45 + € 0,60: 45 + 60 = 105 cent = € 1,05. Dus € 3 + € 1,05 = € 4,05.",
        "solutionSteps": [
          "3 × 20 cent = 60 cent",
          "€ 3,45 + € 0,60",
          "45 + 60 = 105 cent → 1 euro 5 cent",
          "Antwoord: € 4,05"
        ],
        "distractorExplanations": {
          "0": "Goed! € 3,45 + 3 × € 0,20 = € 4,05.",
          "1": "Je hebt maar 1 × 20 cent bijgeteld. 3 × 20 cent = 60 cent.",
          "2": "Je hebt 3 × 10 cent bijgeteld in plaats van 3 × 20 cent.",
          "3": "Bijna! Je bent de overdracht vergeten: 45 + 60 = 105, dus € 4,05 (niet € 3,95 → € 4,15)."
        }
      }
    },
    {
      "id": "GELD-TELLEN-011",
      "familyId": "GELD-TELLEN",
      "module": "Geld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "geld_basis",
      "subSkill": "geld_tellen",
      "questionType": "matching",
      "question": "Koppel elk bedrag aan de bijbehorende verzameling munten/biljetten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "€ 1,20", "right": "1 × € 1 + 1 × 20 cent" },
          { "left": "€ 2,50", "right": "1 × € 2 + 1 × 50 cent" },
          { "left": "€ 5,10", "right": "1 × € 5 (biljet) + 1 × 10 cent" },
          { "left": "€ 0,75", "right": "1 × 50 cent + 1 × 20 cent + 1 × 5 cent" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Bedrag → munten", "content": "Lees de euro's en de centen apart. Zoek dan de combinatie die er precies op uitkomt.", "icon": "lightbulb"}}],
      "conceptId": "geld_matching_bedrag_munten",
      "variantIndex": 11,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "€ 1,20 = € 1 + 20 cent. € 2,50 = € 2 + 50 cent. € 5,10 = € 5 (biljet) + 10 cent. € 0,75 = 50 + 20 + 5 cent.",
        "solutionSteps": [
          "€ 1,20 → € 1 + 20 cent",
          "€ 2,50 → € 2 + 50 cent",
          "€ 5,10 → € 5-biljet + 10 cent",
          "€ 0,75 → 50 + 20 + 5 cent"
        ]
      }
    }
  ]
}

